import React from 'react';

import { StyleSheet } from 'react-native';

import { IBackendCart } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { getDesignToken, spacing } from 'styles/constants';

import { GrandTotalLabel, Total, TotalsRow } from './styled';

interface GrandTotalProps {
  isLoading?: boolean;
  cart?: IBackendCart;
  serverOrderTip?: number;
  tipAmount: number;
}

const GrandTotal: React.FC<React.PropsWithChildren<GrandTotalProps>> = ({
  cart,
  serverOrderTip,
  tipAmount = 0,
  isLoading,
}) => {
  const { totalCents = 0 } = cart || {};
  const grandTotal = Math.max(totalCents - Number(serverOrderTip) + tipAmount, 0);
  const displayedGrandTotal = grandTotal > 0 ? grandTotal : 0;
  const { formatCurrencyForLocale } = useUIContext();

  return (
    <TotalsRow
      style={styles.grandTotalRow}
      accessible={!isLoading}
      focusable={!isLoading}
      accessibilityLabel={
        !isLoading ? `${t('total')}: ${formatCurrencyForLocale(displayedGrandTotal)}` : undefined
      }
    >
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <GrandTotalLabel focusable={false}>{t('total')}</GrandTotalLabel>
          <Total focusable={false}>
            <Currency
              focusable={false}
              testID="grand-total"
              amount={displayedGrandTotal}
              isBold
              textProps={{
                fontSize: 'md',
                color: getDesignToken('text-default'),
                style: { margin: 0, flexGrow: 0 },
              }}
            />
          </Total>
        </>
      )}
    </TotalsRow>
  );
};

export default GrandTotal;

const styles = StyleSheet.create({
  grandTotalRow: {
    marginTop: spacing.$4,
  },
});
